import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import AppBzh from './AppBzh';
import AppJa from './AppJa';
import AppDe from './AppDe';
import { appUrlPaths } from './urlUtils';
import AppIt from './AppIt';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<AppBzh />} />
          <Route path={appUrlPaths.bzh} element={<AppBzh />} />
          <Route path={appUrlPaths.ja} element={<AppJa />} />
          <Route path={appUrlPaths.it} element={<AppIt />} />
          <Route path={appUrlPaths.de} element={<AppDe />} />
          <Route path="*" element={
            <main style={{ padding: '1rem' }}>
              <h2>Nothing to see here!</h2>
              <p>
                <Link to="/">Go to home page</Link>
              </p>
            </main>
          } />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
